import {calculateYearsDifference, taxVatValidator} from "../";

const registerValidator = props => {
    // Destructured props
    const {
        formValues,
        currentStep
    } = props;

    // The regexes for the values to be validated from
    const emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
    const dobRegex = /([0-2][0-9]|3[0-1])\/(0[0-9]|1[0-2])\/[0-9]{4}/;
    const taxVatRegex = new RegExp("^\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}$");
    const zipRegex = new RegExp("^[0-9]{5}-[0-9]{3}$");

    // Validates the year difference from the current year to the year the customer was born
    const checkYearDifference = (dateStr, yearDifferenceRef) => {
        const currentDate = new Date();

        const [day, month, year] = dateStr.split('/');

        const parsedYear = parseInt(year, 10);
        const parsedMonth = parseInt(month, 10) - 1;
        const parsedDay = parseInt(day, 10);

        const providedDate = new Date(parsedYear, parsedMonth, parsedDay);

        const yearDifference = currentDate.getFullYear() - providedDate.getFullYear();

        return yearDifference <= yearDifferenceRef;
    };

    // Actual form field validator for the first step
    const validateFirstStep = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // Validates each field
        switch (target) {
            case "firstname":
                if (!value) {
                    errors.firstname = "Esse campo é obrigatório.";
                } else if (value.split(" ").length < 2) {
                    errors.firstname = "Insira seu nome completo.";
                } else if (value.split(" ")[1] === "") {
                    errors.firstname = "Insira seu nome completo.";
                } else {
                    errors.firstname = "";
                }

                break;
            case "email":
                if (!value) {
                    errors.email = "Esse campo é obrigatório.";
                } else if (value && !emailRegex.test(value)) {
                    errors.email = "Insira um endereço de email válido.";
                } else if (value.endsWith(".co")) {
                    errors.email = "Insira um endereço de email válido.";
                } else {
                    errors.email = "";
                }

                break;
            case "emailConfirm":
                if (!value) {
                    errors.emailConfirm = "Esse campo é obrigatório.";
                } else if (value && value !== formValues.email) {
                    errors.emailConfirm = "Os emails não coincidem.";
                } else {
                    errors.emailConfirm = "";
                }

                break;
            case "password":
                if (!value) {
                    errors.password = "Esse campo é obrigatório.";
                } else if (value && value.length < 8) {
                    errors.password = "Sua senha deve ter no mínimo 8 caracteres.";
                } else {
                    errors.password = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Actual form field validator for the second step
    const validateSecondStep = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // Validates each field
        switch (target) {
            case "dob":
                if (!value) {
                    errors.dob = "Esse campo é obrigatório.";
                } else if (value && !dobRegex.test(value)) {
                    errors.dob = "Insira uma data de nascimento válida.";
                } else if (!checkYearDifference(value, 130)) {
                    errors.dob = "Insira uma data de nascimento válida.";
                } else if (calculateYearsDifference(value) < 16) {
                    errors.dob = "Apenas maiores de 16 anos podem se cadastrar, por favor, solicite ajuda de um responsável.";
                } else {
                    errors.dob = "";
                }

                break;
            case "taxvat":
                if (formValues.isBrazilian) {
                    if (!value) {
                        errors.taxvat = "Esse campo é obrigatório.";
                    } else if (value && (!taxVatRegex.test(value) || !taxVatValidator(value))) {
                        errors.taxvat = "Insira um número de CPF válido.";
                    } else {
                        errors.taxvat = "";
                    }
                } else {
                    errors.taxvat = "";
                }

                break;
            case "passport":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.passport = "Esse campo é obrigatório.";
                    } else {
                        errors.passport = "";
                    }
                } else {
                    errors.passport = "";
                }

                break;
            case "nationality":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.nationality = "Esse campo é obrigatório.";
                    } else {
                        errors.nationality = "";
                    }
                } else {
                    errors.nationality = "";
                }

                break;
            case "gender":
                if (!value) {
                    errors.gender = "Esse campo é obrigatório.";
                } else {
                    errors.gender = "";
                }

                break;
            case "affiliation":
                if (!value) {
                    errors.affiliation = "Esse campo é obrigatório.";
                } else if (value && value.split(" ").length < 2) {
                    errors.affiliation = "O nome deve possuir no mínimo duas palavras.";
                } else {
                    errors.affiliation = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Actual form field validator for the second step
    const validateThirdStep = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // Validates each field
        switch (target) {
            case "postcode":
                if (formValues.address_country) {
                    if (!value) {
                        errors.postcode = "Esse campo é obrigatório.";
                    } else if (value && !zipRegex.test(value)) {
                        errors.postcode = "Insira um cep válido.";
                    } else {
                        errors.postcode = "";
                    }
                } else {
                    errors.postcode = !value ? "Esse campo é obrigatório." : "";
                }

                break;
            case "state":
                if (formValues.address_country) {
                    if (!value) {
                        errors.state = "Esse campo é obrigatório.";
                    } else {
                        errors.state = "";
                    }
                } else {
                    errors.state = "";
                }

                break;
            case "country":
                if (!formValues.address_country) {
                    if (!value) {
                        errors.country = "Esse campo é obrigatório.";
                    } else {
                        errors.country = "";
                    }
                } else {
                    errors.country = "";
                }

                break;
            case "address":
                if (!value) {
                    errors.address = "Esse campo é obrigatório.";
                } else {
                    errors.address = "";
                }

                break;
            case "neighborhood":
                if (!value) {
                    errors.neighborhood = "Esse campo é obrigatório.";
                } else {
                    errors.neighborhood = "";
                }

                break;
            case "city":
                if (!value) {
                    errors.city = "Esse campo é obrigatório.";
                } else {
                    errors.city = "";
                }

                break;
            case "phoneNumber":
                if (!value) {
                    errors.phoneNumber = "Esse campo é obrigatório.";
                } else {
                    errors.phoneNumber = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Method to perform a validation in all fields at once
    const validateAll = () => {
        let errors = {};

        // Iterates through each field validating them
        Object.keys(formValues).forEach(key => {
            const args = {
                target: key,
                value: formValues[key]
            }

            errors = {
                ...errors,
                ...(
                    currentStep === 1 ?
                        validateFirstStep(args) :
                        currentStep === 2 ?
                            validateSecondStep(args) :
                            validateThirdStep(args)
                )
            }
        })

        // Returns the errors object to be set into the errors state
        return errors;
    }

    return {
        validateFirstStep,
        validateSecondStep,
        validateThirdStep,
        validateAll
    }
}

export default registerValidator;
